import "./index.scss";

export const GiftNotification = ({ gifter }) => (
  <div className="gift-notification" data-testid="gift-notification">
    <h1 className="notification-title">
      Surprise!
      <br />
      You received a gift from {gifter}.
    </h1>
    <div className="notification-text">
      Fill in the fields below to set up your account and access your gift card.
    </div>
  </div>
);
